import * as Types from '../../tenants/kwg/generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';


export const SetUserSettingDocument = `
    mutation SetUserSetting($input: SetUserSettingCommandInput!) {
  setUserSetting(input: $input) {
    key
  }
}
    `;

export const useSetUserSettingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<Types.SetUserSettingMutation, TError, Types.SetUserSettingMutationVariables, TContext>) => {
    
    return useMutation<Types.SetUserSettingMutation, TError, Types.SetUserSettingMutationVariables, TContext>(
      {
    mutationKey: ['SetUserSetting'],
    mutationFn: (variables?: Types.SetUserSettingMutationVariables) => fetcher<Types.SetUserSettingMutation, Types.SetUserSettingMutationVariables>(SetUserSettingDocument, variables)(),
    ...options
  }
    )};
